module.exports = __webpack_public_path__ + "img/graduate.dcdf12d.svg";